import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../Button';
import DSIcon from '../../../base/DSIcon';

import styles from './CollapsibleText.module.scss';

const CollapsibleText = ({
  children,
  showMoreText,
  showLessText,
  isCollapsed: isCollapsedProp = true,
  showIcon = true,
  collapseCompletely = false
}) => {
  const [isCollapsed, setIsCollapsed] = useState(isCollapsedProp);

  const contentClassName = classNames(styles['collapsible-text__content'], {
    [styles['collapsible-text__content--collapsed']]: isCollapsed,
    [styles['collapsible-text__content--expanded']]: !isCollapsed,
    [styles['collapsible-text__content--collapse-completely']]:
      collapseCompletely
  });

  const handleToggleCollapse = () => {
    setIsCollapsed(collapsed => !collapsed);
  };

  const buttonLocoKey = isCollapsed ? showMoreText : showLessText;
  const iconName = isCollapsed ? 'arrow_full_bottom' : 'arrow_full_top';

  return (
    <div className="collapsible-text">
      <div className={contentClassName}>{children}</div>
      <Button
        color="link"
        onClick={handleToggleCollapse}
        renderTrailingIcon={() =>
          showIcon ? <DSIcon name={iconName} /> : null
        }
        renderContent={() => buttonLocoKey}
      />
    </div>
  );
};

CollapsibleText.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  showMoreText: PropTypes.string.isRequired,
  showLessText: PropTypes.string.isRequired,
  isCollapsed: PropTypes.bool,
  showIcon: PropTypes.bool,
  collapseCompletely: PropTypes.bool
};

export default CollapsibleText;
